import{gql as e}from"@apollo/client";const t=e`
  query getCartoonScene(
  $projectId: String!
  $sceneUrl: String!
) {
  contentPage {
    getCartoonScene: getContentPagePerName(
      contentPageUrl: $sceneUrl, 
      projectId: $projectId
    ) {
      contentGroupId
      ...cartoonPage
      contentPageChildren(status: [PUBLISHED]) {
        ...cartoonPage
      }
    }
  }
}

fragment cartoonPage on ContentPageType {
    hasBeenViewed
    seoTitle
    sort
    title
    id
    url
    minimumExposureTime
    asset {
      assetId
      presignedUrl
    }
    bubbleTexts {
      angle
      character {
        id
        image {
          presignedUrl
        }
        name
        projectId
      }
      characterId
      id
      isTailVisible
      hasShadow
      shape
      tailType
      sort
      text
      w
      x
      y
    }
    audio {
      presignedUrl
      publicUrl
    }
  }`;export{t as GET_CARTOON_SCENE};
//# sourceMappingURL=useGetCartoonScene.graphql.js.map
